import { Box, Grid, styled, Tab, Table, Tabs, Typography } from '@mui/material';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: '1rem',
    fontWeight: 400,
    borderBottom: `0.0625rem solid ${theme.palette.brand.charcoal}`,
    '&.base-settings': {
      textAlign: 'left',
    },
    '&.configuration': {
      textAlign: 'left',
    },
    '&.color': {
      textAlign: 'left',
      paddingRight: '54px',
    },
    '&.font-family': {
      textAlign: 'left',
      paddingRight: '7.5rem',
    },
    '&.font-size': {
      textAlign: 'left',
      paddingRight: '1.875rem',
    },
    '&.line-height': {
      textAlign: 'left',
    },
    '&.height': {
      textAlign: 'left',
      paddingLeft: '2.1875rem',
    },
  },

  [`&.${tableCellClasses.body}`]: {
    fontSize: '1rem',
    fontWeight: 400,
  },
}));

export const AntTab = styled((props: any) => <Tab disableRipple {...props} />)(
  ({ theme, haserror }) => `
    text-transform: none;
    color: ${
      haserror ? theme.palette.error.main : theme.palette.brand.charcoal
    };
    
    font-weight: 400;
    font-size: 0.9375rem;
  `,
);

export const AntTabs = styled(Tabs)`
  margin-left: 1.4rem;
  margin-top: 0.9375rem;
  width: auto;
  left: 0.625rem;
`;

export const ThemesTitle = styled(Typography)(
  () => `
  font-weight: 500;
  margin-top: 0.9375rem;
  margin-bottom: 0.9375rem;
  `,
);

export const ThemesLabel = styled(Typography)(
  () => `
  font-weight: 300;
  `,
);

export const ThemeContainer = styled(Table)`
  padding: 0.1875rem;
`;

export const StyledInputContainer = styled(Box)`
  & .MuiInputBase-root {
    height: 56px;
  }
`;

export const StyledGridContainer = styled(Grid)({
  width: '100%',
});

export const StyledGridItem = styled(Grid)({
  width: '50%',
});

export const StyledGridItemLastChild = styled(Grid)({
  marginLeft: 'auto',
});
